import styled from 'styled-components/macro';

// import theme helpers
import { getBreakpoint, getColor } from '../../../util/theme';

const ReviewsCarouselWrapper = styled.div`
  position: relative;

  .control {
    display: none;

    position: absolute;
    top: 35%;
    z-index: 999;

    font-size: 5rem;

    cursor: pointer;

    @media (min-width: ${getBreakpoint('xl')}) {
      display: block;
    }

    &:hover {
      svg {
        polygon {
          fill: ${getColor('accentGreen')};
        }
      }
    }

    &.left {
      left: -50px;
    }

    &.right {
      right: -50px;
    }

    svg {
      polygon {
        fill: ${getColor('white')};
      }
    }
  }
`;

export default ReviewsCarouselWrapper;
